// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZHnV","left":"styles_left__jqcp1"};